import { useTranslation } from 'react-i18next';

export default function Hero() {
  const { t } = useTranslation();
  return (
    <section id="home" className="relative flex min-h-screen w-full items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=dark%20moody%20premium%20Indian%20restaurant%20hero%20background%20with%20tandoor%20kebabs%20naan%20bread%20and%20vibrant%20curries%20on%20a%20dark%20wooden%20table%2C%20warm%20amber%20candlelight%20and%20hanging%20brass%20lanterns%2C%20rich%20golden%20and%20charcoal%20tones%2C%20cinematic%20depth%2C%20artistic%20appetizing%20food%20photography&width=1800&height=1200&seq=hero-bg-01&orientation=landscape&nocache=true"
          alt="A warm Indian feast of tandoor kebabs, naan and curries at Mehfil 24/7"
          className="h-full w-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/70"></div>
      </div>

      <div className="relative z-10 mx-auto flex w-full max-w-4xl flex-col items-center px-4 py-32 text-center md:py-40">
        <span className="mb-6 inline-flex items-center gap-2 rounded-full border border-accent-400/50 bg-black/30 px-5 py-2 text-xs tracking-[0.3em] uppercase text-accent-300 backdrop-blur">
          <i className="ri-time-line text-sm"></i>
          {t('hero.badge')}
        </span>

        <h1 className="text-4xl font-semibold leading-tight text-background-50 md:text-6xl">
          {t('hero.title1')}{' '}
          <span className="italic text-accent-400">{t('hero.highlight')}</span>
          <br className="hidden md:block" /> {t('hero.title2')}
        </h1>

        <p className="mt-6 max-w-2xl text-base text-background-100/90 md:text-lg">
          {t('hero.subtitle')}
        </p>

        <div className="mt-9 flex flex-col gap-3 sm:flex-row sm:items-center">
          <a
            href="#menu"
            className="inline-flex items-center justify-center gap-2 rounded-full bg-primary-500 px-7 py-3.5 text-sm font-semibold text-background-50 whitespace-nowrap transition-colors hover:bg-primary-600"
          >
            {t('hero.explore')}
            <i className="ri-arrow-right-line"></i>
          </a>
          <a
            href="#contact"
            className="inline-flex items-center justify-center gap-2 rounded-full border border-background-50/60 bg-background-950/20 px-7 py-3.5 text-sm font-semibold text-background-50 whitespace-nowrap backdrop-blur transition-colors hover:bg-background-50/10"
          >
            <i className="ri-bike-line"></i>
            {t('hero.delivery')}
          </a>
        </div>

        <div className="mt-12 grid w-full grid-cols-3 gap-4 border-t border-background-50/20 pt-8 text-center md:max-w-lg">
          <div className="flex flex-col items-center">
            <span className="text-2xl font-semibold text-accent-400 md:text-3xl">{t('hero.stat1v')}</span>
            <span className="mt-1 text-xs text-background-100/80 md:text-sm">{t('hero.stat1l')}</span>
          </div>
          <div className="flex flex-col items-center">
            <span className="text-2xl font-semibold text-accent-400 md:text-3xl">{t('hero.stat2v')}</span>
            <span className="mt-1 text-xs text-background-100/80 md:text-sm">{t('hero.stat2l')}</span>
          </div>
          <div className="flex flex-col items-center">
            <span className="text-2xl font-semibold text-accent-400 md:text-3xl">{t('hero.stat3v')}</span>
            <span className="mt-1 text-xs text-background-100/80 md:text-sm">{t('hero.stat3l')}</span>
          </div>
        </div>
      </div>
    </section>
  );
}